import React, { FunctionComponent } from 'react';

const FullScreenLoader: FunctionComponent = () => (
  <div className="loader">
  </div>
);

export default FullScreenLoader;
